// import * as actionTypes from './actionTypes';
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	users: {
		error: '',
		results: [],
		total: 0,
		hasBeenLoaded: false,
		isLoading: false
	}
};

export const usersSlice = createSlice({
	name: 'users',
	initialState,
	reducers: {
		getUsers: (state) => {
			state.users.isLoading = true;
		},
		getUsersCompleted: (state, action) => {
			state.users.isLoading = false;
			state.users.results = action.payload.results;
			state.users.total = action.payload.total;
			state.users.hasBeenLoaded = true;
			state.users.error = '';
		},
		getUsersFailed: (state, action) => {
			state.users.isLoading = false;
			state.users.hasBeenLoaded = false;
			state.users.error = action.payload;
		}
	}
});

export const { getUsers, getUsersCompleted, getUsersFailed } =
	usersSlice.actions;

export default usersSlice.reducer;
